import { render } from "./ColumnList.vue?vue&type=template&id=2f809fa5&scoped=true&ts=true"
import script from "./ColumnList.vue?vue&type=script&lang=ts"
export * from "./ColumnList.vue?vue&type=script&lang=ts"

import "./ColumnList.vue?vue&type=style&index=0&id=2f809fa5&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f809fa5"]])

export default __exports__